import apiFetch from '../apiFetch'

export default function (idCambioEstadoVerraco, token) {
  return apiFetch({endPoint: `CambioEstadoVerraco/getCambioEstado?idCambioEstado=` + idCambioEstadoVerraco, method: 'GET', body: null, token: token})
}
